export enum EntityFormId {
    Create = 'create',
    QuickCreate = 'quick-create',
    Manage = 'manage',
    ManageFinancial = 'manage-financial',
}